import React from "react";

export default [
  {
    name: "blog",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">个人博客</div>
        <div className="portfolio-item__desc">
          不定时分享前端，算法，效率技巧，成长心得等
        </div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
          <i className="fab fa-terminal" />
          <i className="fab fa-blogger"></i>
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://lucifer.ren/blog/"
          >
            地址
          </a>
        </div>
      </div>
    )
  },

  {
    name: "daily-featured",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">每日一荐</div>
        <div className="portfolio-item__desc">
          每天给你推荐一个新奇，好玩，高品质的开源库，好文，观点或言论等。
        </div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
          <i className="fab fa-terminal" />
          <i className="fas fa-book-reader"></i>
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/daily-featured"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "automate-everything",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">我的第一本书</div>
        <div className="portfolio-item__desc">
          内容覆盖前后端分离，模块化和组件化，流程自动化，页面加载性能优化等。
        </div>
        <div className="portfolio-item__icon">
          <i className="fab fa-html5" />
          <i className="fab fa-css3" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/automate-everything"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "fe-interview",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">fe-interview</div>
        <div className="portfolio-item__desc">宇宙最强的前端面试指南</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/fe-interview"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "leetcode",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">leetcode题解</div>
        <div className="portfolio-item__desc">我的leetcode题解之路</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
          <i className="fab fa-python"></i>
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/leetcode"
          >
            地址
          </a>
        </div>
      </div>
    )
  },

  {
    name: "zhuque",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">朱雀</div>
        <div className="portfolio-item__desc">前端监控平台</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
          <i className="fab fa-npm" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/zhuque"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "qy",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">小门神</div>
        <div className="portfolio-item__desc">一站式前端自动检测平台</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-terminal" />
          <i className="fab fa-js" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/qy"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "duiba-siri",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">siri</div>
        <div className="portfolio-item__desc">兑吧小助手，让你专注做需求。</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-terminal" />
          <i className="fab fa-js" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/renliwo/siri"
          >
            地址
          </a>
        </div>
      </div>
    )
  },
  {
    name: "mono-series",
    render: (
      <div className="portfolio-item">
        <div className="portfolio-item__title">mono-series</div>
        <div className="portfolio-item__desc">造轮子系列</div>
        <div className="portfolio-item__icon">
          <i className="fab fa-js" />
        </div>
        <div className="portfolio-item__links">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/azl397985856/mono-series/tree/master"
          >
            地址
          </a>
        </div>
      </div>
    )
  }
];



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js